<template>
  <div>
    <div class="px-6">
      <div>
        <label class="text-lg font-semibold text-black mb-0"
          >Template Name</label
        >
        <el-input
          placeholder="Enter Template Name"
          v-validate="'required'"
          v-model="templateName"
          maxlength="50"
          class="w-full mt-2"
          name="template"
          data-vv-validate-on="input|blur"
        ></el-input>
        <p v-if="errors.has('template')" class="text-danger">
          {{ errors.first("template") }}
        </p>
        <div class="mt-6">
          <label class="text-lg font-semibold text-black mb-0">Sender ID</label>
          <el-select
            placeholder="Sender ID"
            class="w-full mt-2"
            value-key="_id"
            v-model="category"
            name="senderId"
            v-validate="'required'"
            data-vv-validate-on="input|blur"
          >
            <el-option
              v-for="item in smsConfig"
              :key="item._id"
              :label="item.sender"
              :value="item"
            >
            </el-option>
          </el-select>
          <p v-if="errors.has('senderId')" class="text-danger">
            {{ errors.first("senderId") }}
          </p>
        </div>
      </div>
      <div class="mt-6">
        <label class="text-lg font-semibold text-black mb-0">SMS Body</label>
        <el-input
          placeholder="Enter Template Name"
          v-model="body"
          type="textarea"
          class="w-full mt-2"
          maxlength="200"
          :autosize="{ minRows: 8, maxRows: 8 }"
          v-validate="'required'"
          name="smsBody"
          data-vv-validate-on="input|blur"
        ></el-input>
        <p v-if="errors.has('smsBody')" class="text-danger">
          {{ errors.first("smsBody") }}
        </p>
      </div>
      <!-- <div class="mt-6">
        <label class="text-lg font-semibold text-black mb-0">Example</label>
        <el-input
          placeholder="Enter Template Name"
          v-model="example"
          type="textarea"
          class="w-full mt-2"
          :autosize="{ minRows: 8, maxRows: 8 }"
        ></el-input>
      </div> -->
    </div>

    <div class="flex justify-center mt-10">
      <vs-button
        @click="handleSubmit()"
        class="bgraw rounded-full border-0 col-purple font-semibold lg:py-3 fsize14 md:py-3 py-2 px-10 sm-fsize14"
      >
        Submit
      </vs-button>
    </div>
  </div>
</template>
<script>
import { VueEditor } from "vue2-quill-editor";
import { mapState } from "vuex";

export default {
  data() {
    return {
      templateName: "",
      body: "",
      example: "",
      smsConfig: [],
      category: "",
    };
  },
  async mounted() {
    await this.getSmsConfig();
  },
  methods: {
    async getSmsConfig() {
      let data = await this.$store.dispatch("smsCampaign/getSmsConfig", {
        projectId: this.selectedProject._id,
      });
      this.smsConfig = data;
    },
    async handleSubmit() {
      try {
        this.$validator.validateAll().then(async (result) => {
          if (result) {
            let payload = {
              templateName: this.templateName,
              senderId: this.category,
              body: this.body,
              projectId: this.selectedProject._id,
              displayName: this.selectedProject.displayName,
              projectName: this.selectedProject.projectName,
            };

            let data = await this.$store.dispatch(
              "controlCenter/createSms",
              payload
            );

            if (data.code == 200) {
              this.$swal({
                title: "SUCCESS",
                text: "Sms Template is successfully submitted",
                icon: "success",
                confirmButtonColor: "#830c81",
                confirmButtonText: "OK",
              });
              this.templateName = "";
              this.body = "";
              this.category = "";
              this.$emit("apiCallSms");
              this.$validator.reset();
              this.errors.clear();
            }
          }
        });

        // console.log(data);
      } catch (err) {
        console.log(err);
      }
    },
  },
  props: {
    drawer: { type: Boolean },
  },
  watch: {
    drawer(value) {
      if (value) {
        this.$validator.reset();
        this.errors.clear();
      }
    },
  },
  computed: {
    ...mapState("user", { selectedProject: "selectedProject" }),
    ...mapState("admin", { login: "login" }),
  },
  components: {
    VueEditor,
  },
};
</script>
